/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './en.json';

Vue.use(VueI18n);

const loadedLanguages = ['en'];

// // Load all locales and remember context
// function loadMessages() {
//   const context = require.context('../', true, /[a-z0-9-_]+(\.i18n)?\.json$/i);
//   const messages = context
//     .keys()
//     .map(key => ({
//       key,
//       locale: (key.match(/.*\/([a-z0-9-_]+(\.i18n)?)/i) || [])[1],
//     }))
//     .reduce((agg, { key, locale }) => {
//       console.log('locale:', locale);
//       const data = context(key);
//       if (locale.endsWith('.i18n')) {
//         return {
//           ...agg,
//           ...data,
//         };
//       }
//       return {
//         ...agg,
//         [locale]: data,
//       };
//     }, {} as HashAny);
//   return { context, messages };
// }
// const { context, messages } = loadMessages();

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: { en },
});

export default i18n;

export function setI18nLanguage(lang: string) {
  i18n.locale = lang;
  const htmlEl = document.querySelector('html');
  if (htmlEl) {
    htmlEl.setAttribute('lang', lang);
  }
  // axios.defaults.headers.common['Accept-Language'] = lang;
}

export async function loadLanguageAsync(lang: string) {
  if (i18n.locale === lang || loadedLanguages.includes(lang)) {
    setI18nLanguage(lang);
    return;
  }

  const messages = await import(
    /* webpackMode "lazy" */
    /* webpackChunkName: "lang-[request]" */ `./${lang}.json`
  );
  i18n.setLocaleMessage(lang, messages);
  loadedLanguages.push(lang);

  setI18nLanguage(lang);
}

export function setDebugMode(value: boolean) {
  if (value) {
    if (typeof i18n.postTranslation === 'function') {
      return;
    }
    i18n.postTranslation = (str: string, key?: string) => key || '[no key]';
  } else {
    if (i18n.postTranslation == null) {
      return;
    }
    (i18n as HashAny).postTranslation = null;
  }
  const { locale } = i18n;
  i18n.locale = '__none__';
  i18n.locale = locale;
}

if (module.hot) {
  // module.hot.accept(context.id, () => {
  //   const { locales } = loadMessages();
  //   locales.forEach(({ key, locale }) => {
  //     i18n.setLocaleMessage(locale, context(key));
  //   });
  // });
  module.hot.accept(
    [
      '../i18n/en.json',
      '../i18n/ja.json',
      '../i18n/ms.json',
      '../i18n/zh-CN.json',
      '../i18n/zh-TW.json',
      // '../components/XXX.i18n.json',
      // ...
    ],
    () => {
      // load base i18n files
      const msgs: HashAny = {
        'en': require('../i18n/en.json'),
        'ja': require('../i18n/ja.json'),
        'ms': require('../i18n/ms.json'),
        'zh-CN': require('../i18n/zh-CN.json'),
        'zh-TW': require('../i18n/zh-TW.json'),
      };
      Object.keys(msgs).forEach(locale => {
        i18n.setLocaleMessage(locale, msgs[locale]);
      });
      // {
      //   // merge additional i18n files
      //   const all = require('../components/XXX.i18n.json');
      //   Object.keys(all).forEach(locale => {
      //     i18n.mergeLocaleMessage(locale, msgs[locale]);
      //   });
      // }
    },
  );
}

// // Hot updates
// if (module.hot) {
//   module.hot.accept(context.id, () => {
//     const { messages: newMessages } = loadMessages();

//     Object.keys(newMessages)
//       .filter(locale => messages[locale] !== newMessages[locale])
//       .forEach(locale => {
//         console.log('updating locale:', locale);
//         if (locale.endsWith('.i18n')) {
//           Object.keys(newMessages).forEach(_locale => {
//             messages[_locale] = {
//               ...messages[_locale],
//               ...newMessages[_locale],
//             };
//             i18n.setLocaleMessage(_locale, messages[_locale]);
//           });
//         } else {
//           messages[locale] = newMessages[locale];
//           i18n.setLocaleMessage(locale, messages[locale]);
//         }
//       });
//   });
// }
